import { Component, OnInit, AfterViewInit, OnChanges, SimpleChanges, Input, Output, OnDestroy } from '@angular/core';
import { WidgetStatusBreakupService } from './service/widget-status-breakup.service';
import * as Highcharts from "highcharts";
import * as HSET from "./settings";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from '@ngx-translate/core';
import { outputFile } from 'fs-extra';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonService } from "../../../../shared/services";
import { GenericUtils } from "../../../utilities/generic-utils"
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: 'widget-status-breakup',
  templateUrl: './widget-status-breakup.component.html',
  styleUrls: ['./widget-status-breakup.component.scss'],
  providers: [WidgetStatusBreakupService]
})
export class WidgetStatusBreakupComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;
  @Output() componentChange;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  dropdownItems = []
  origin_fc = 'All'
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetStatusBreakupService,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute,
    private utils: GenericUtils
  ) { }

  ngAfterViewInit() {
    this.getStatusBreakup();
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS));
    this.translateService.get("OVERALL_STATUS.STATUS_BREAKUP").pipe(takeUntil(this.unsubscribe)).subscribe(text => {
      this.OPTIONS.title = this.OPTIONS.title || text;
    });
    this.getFilterData()
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
        const fcCode = this.FILTERS['origin_fc_code'];
        if (fcCode) {
          this.FILTERS['origin_fc_code'] = fcCode.split(' / ')[1] ? fcCode.split(' / ')[1] : fcCode;

        }
        this.FILTERS = this.utils.cleanNullKeys(this.FILTERS);
        this.getStatusBreakup();
        this.getFilterData();
      } else {
        this.FILTERS = JSON.parse(JSON.stringify(intiFilter));
        this.getStatusBreakup();
        this.getFilterData();
      }
    })
  }

  getStatusBreakup() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    const options = {
      url: this.OPTIONS.api,
      params: this.FILTERS,
      query: ""
    };

    this.dataService.getData(options).pipe(takeUntil(this.unsubscribe)).subscribe(
      chartData => {
        if (chartData && chartData.allValues && chartData.allValues.length) {
          this.chartOptions = this.dataService.createChart(
            chartData,
            this.OPTIONS
          );
        }
        else {
          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }

  getFilterData() {
    this.dropdownItems = [];
    const options = {
      url: "/81/e2e/config/filter/facility/name/v2",
      params: { "delhivery_facility_type": ["STORAGE"] }
    };
    this.dataService.getfilters(options).pipe(takeUntil(this.unsubscribe)).subscribe(originFCValues => {
      let __temp_dropdown = [...originFCValues.data[0].filters];
      __temp_dropdown.map(element => {
        this.dropdownItems.push({ 'label': element['client_facility_name'] + ' / ' + element['client_facility_code'], 'value': element['client_facility_name']})
      });
      // this.dropdownItems.unshift({'client_facility_name':'All', 'client_facility_code':''})
      this.dropdownItems.unshift({ 'label': 'ALL', 'value': ''});
    })
  }

  dropdownChange(event) {
    if (event['client_facility_name'] != "All") {
      this.origin_fc = `${event['client_facility_code']}/${event['client_facility_name']}`
      this.FILTERS['origin_fc_code'] = event['client_facility_code'];
    } else {
      delete this.FILTERS['origin_fc_code']
      this.origin_fc = 'All'
    }
    this.getStatusBreakup()
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
